export const allowOnlyNumber = (value: any) => value?.replace(/[^0-9]/g, "")

export const allowOnlyNumberAndHyphen = (value: any) =>
  value?.replace(/[^0-9-]/g, "")
